module.exports = __webpack_public_path__ + "static/media/R1.97fe4a85.jpg";